import type { Locale } from './config';

/**
 * Keep `<html lang>` in step with the active locale.
 *
 * Not cosmetic: screen readers pick a pronunciation dictionary from it, so a
 * Malay page still marked `lang="en"` is read aloud with English phonetics.
 * It is also what `:lang()` selectors and browser translation prompts key off.
 *
 * A no-op without a document, so the same call is safe during a prerender.
 */
export function syncDocumentLang(locale: Locale, doc: Document | undefined = globalThis.document) {
  if (doc === undefined) return;
  doc.documentElement.lang = locale;
}
